import api from '../../../../api/client'

/**
 * Downloads standard Excel template generated dynamically by openpyxl backend.
 * @param {'students' | 'fees'} type
 */
export const downloadSampleTemplate = async (type = 'students') => {
  const response = await api.get('/admission/upload-excel/template', {
    params: { type },
    responseType: 'blob',
  })

  const filename =
    type === 'fees'
      ? 'Fees_Structure_Template.xlsx'
      : 'Students_Upload_Template.xlsx'

  const blob = new Blob([response.data], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  })
  const url = window.URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.setAttribute('download', filename)
  document.body.appendChild(link)
  link.click()
  link.remove()
  window.URL.revokeObjectURL(url)
}

/**
 * Downloads fees structure sample template.
 */
export const downloadFeesSampleTemplate = async () => {
  return downloadSampleTemplate('fees')
}

/**
 * Uploads student bulk enrollment spreadsheet.
 * @param {File} file
 */
export const uploadStudentExcel = async (file) => {
  if (!file) {
    throw new Error('No file selected')
  }

  const formData = new FormData()
  formData.append('file', file)

  const { data } = await api.post('/admission/upload-excel/upload?type=students', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
  return data
}

/**
 * Uploads student fees structure spreadsheet.
 * @param {File} file
 */
export const uploadFeesExcel = async (file) => {
  if (!file) {
    throw new Error('No file selected')
  }

  const formData = new FormData()
  formData.append('file', file)

  const { data } = await api.post('/admission/upload-excel/upload?type=fees', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
  return data
}
